import moment, { Moment } from 'moment';

export const getEffectiveExperienceDate = (
  fromDate: string | Moment,
  selectedDayNumber: number | undefined,
  fallbackDayNumber: number | number[]
): { effectiveDayNumber: number; formattedDate: string } => {
  const effectiveDayNumber =
    selectedDayNumber !== undefined
      ? selectedDayNumber
      : Array.isArray(fallbackDayNumber)
      ? fallbackDayNumber[0]
      : fallbackDayNumber;

  const formattedDate = moment(fromDate).add(effectiveDayNumber, 'days').format('YYYY-MM-DD');

  return { effectiveDayNumber, formattedDate };
};
